import { Page } from '../../../../../components/page/page';
import { useLang } from '../../../../../hooks/use-lang';
import { CompanyBase } from './company-base/company-base';
import s from './company-settings.module.css';
import { CompanySocials } from './company-socials/company-socials';

export const CompanySettings = () => {
  const { t } = useLang();

  return (
    <Page className={s.page}>
      <h2>{t('Настройки компании')}</h2>
      <div className={s.content}>
        <CompanyBase />
        <CompanySocials />
      </div>
    </Page>
  );
};
